import { Product } from "data/data";

export type CartAction =
  | { type: "ADD_TO_CART"; payload: Product }
  | { type: "QUICK_ADD"; payload: Product }
  | { type: "EDIT_CART"; payload: Product & { cartItemId: number } }
  | { type: "REMOVE_ITEMS"; payload: { cartItemId?: number } }
  | { type: "HANDLE_INCREMENT"; payload: { cartItemId?: number } }
  | { type: "HANDLE_DECREMENT"; payload: { cartItemId?: number } }
  | { type: "CLEAR_CART" };

export interface CartState {
  Products: Product[];
  total_price: number;
}

const CartReducer = (state: CartState, action: CartAction): CartState => {
  switch (action.type) {
    case "QUICK_ADD": {
      // For simple items (no modifiers) -- auto-increment if already in cart
      const existingIndex = state.Products.findIndex(
        (item) => item.id === action.payload.id
      );

      if (existingIndex >= 0) {
        const updatedProducts = state.Products.map((item, index) => {
          if (index === existingIndex) {
            return { ...item, quantity: (item.quantity || 1) + 1 };
          }
          return item;
        });
        return { ...state, Products: updatedProducts };
      }

      return {
        ...state,
        Products: [
          ...state.Products,
          { ...action.payload, quantity: 1, cartItemId: Date.now() },
        ],
      };
    }

    case "ADD_TO_CART": {
      const existingItemIndex = state.Products.findIndex(
        (item) =>
          item.id === action.payload.id &&
          JSON.stringify(item.modifierChecked) ===
            JSON.stringify(action.payload.modifierChecked)
      );

      if (existingItemIndex >= 0) {
        const updatedProducts = state.Products.map((item, index) => {
          if (index === existingItemIndex) {
            return {
              ...item,
              quantity: (item.quantity || 0) + (action.payload.quantity || 1),
            };
          }
          return item;
        });
        return { ...state, Products: updatedProducts };
      }

      return {
        ...state,
        Products: [
          ...state.Products,
          {
            ...action.payload,
            quantity: action.payload.quantity || 1,
            cartItemId: Date.now(),
          },
        ],
      };
    }

    case "EDIT_CART": {
      const { modifierChecked, cartItemId, quantity, note } = action.payload;
      const updatedProducts = state.Products.map((item) => {
        if (item.cartItemId === cartItemId) {
          return { ...item, modifierChecked, quantity, note };
        }
        return item;
      });
      return { ...state, Products: updatedProducts };
    }

    case "REMOVE_ITEMS": {
      const filterProduct = state.Products.filter(
        (item) => item.cartItemId !== action.payload.cartItemId
      );
      return { ...state, Products: filterProduct };
    }

    case "HANDLE_DECREMENT": {
      const updatedDataDec = state.Products.map((item) => {
        if (
          item.cartItemId === action.payload.cartItemId &&
          (item.quantity || 0) > 1
        ) {
          return { ...item, quantity: (item.quantity || 1) - 1 };
        }
        return item;
      });
      return { ...state, Products: updatedDataDec };
    }

    case "HANDLE_INCREMENT": {
      const updatedDataInc = state.Products.map((item) => {
        if (item.cartItemId === action.payload.cartItemId) {
          return { ...item, quantity: (item.quantity || 1) + 1 };
        }
        return item;
      });
      return { ...state, Products: updatedDataInc };
    }

    case "CLEAR_CART":
      return { ...state, Products: [] };

    default:
      return state;
  }
};

export default CartReducer;
